import React, { ReactElement } from 'react';
import ChartPie from '../../../components/chart-pie/chart-pie.component';
import Widget from '../../../components/widget/widget.component';
import { WIDGET_NAME_DEALS_BY_TYPE } from '../../../constants/system/widget-names';

const DashboardWidgetDealsByType: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_CONTAINER_CHART_DEALS_BY_TYPE: string = 'container-chart-deals-by-type';
  const WIDGET_TITLE_DEFAULT: string = 'Deal Types Viewed';

  const {
    dealTypeListData,
    widgetSettings,
  } = props;

  const chartItemList: ChartPieItem[] = dealTypeListData && dealTypeListData.length
    ? dealTypeListData.map((dealTypeItem: DealType): ChartPieItem => ({
      name: dealTypeItem.title,
      value: dealTypeItem.dealsTotal,
    })) : [];

  return (
    <Widget
      isEmpty={!dealTypeListData || !dealTypeListData.length}
      widgetName={WIDGET_NAME_DEALS_BY_TYPE}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
      widgetSettings={widgetSettings}
    >
      <ChartPie
        containerId={ID_CONTAINER_CHART_DEALS_BY_TYPE}
        chartItemList={chartItemList}
      />
    </Widget>
  );
});

export default DashboardWidgetDealsByType;
